export const loginInitialValues = {
  email: "",
  password: "",
};

export const forgotPasswordInitialValues = {
  email: "",
};
